import AddIcon from "@mui/icons-material/Add";
import {
  Box,
  InputAdornment,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import SearchIcon from "../../../assets/icons/search-icon.png";
import GlobalButton from "../../../components/button";

let serchStyle = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "50px",
    backgroundColor: "#ffffff",
    fontSize: "0.875rem",
    "& .MuiOutlinedInput-input": {
      padding: "8px 8px !important",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: `1px solid #E99509`,
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      border: `1px solid #E99509`,
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: `1px solid #E99509`,
    },
  },
};

const SearchTab = ({
  handleOpenAddDialog,
  tableData,
  searchValue,
  setSearchValue,
  handleFilterData
}) => {
 

  return (
    <>
      <Stack
        my={2}
        px={1}
        py={2}
        gap={2}
        direction={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
        bgcolor={"primary.light"}
        flexWrap={"wrap"}
      >
        <Stack
          direction={"row"}
          alignItems={"center"}
          gap={2}
          flex={1}
          flexWrap={"wrap"}
        >
          <Typography
            variant={"body2"}
            fontSize={"0.75rem"}
            color={"secondary.dark"}
          >
            connections ({tableData?.length})
          </Typography>
          <Box width={{ xs: "100%", sm: 250 }}>
            <TextField
              fullWidth
              variant="outlined"
              placeholder="Search id / Name / email"
              value={searchValue}
              onChange={handleFilterData}
              sx={serchStyle}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <img src={SearchIcon} width={16} />
                  </InputAdornment>
                ),
              }}
            />
          </Box>
          {/* uncommit later */}
          {/* <CustomRangePicker
            stackProps={{
              boxShadow: "rgba(0, 0, 0, 0.09) 0px 3px 12px",
              borderRadius: "6px",
            }}
          /> */}
        </Stack>
        <GlobalButton
          variant={"custom_gradient"}
          title={"Add new"}
          startIcon={<AddIcon />}
          handleClickBtn={handleOpenAddDialog}
          style={{
            width: { xs: "100%", sm: 130 },
            borderRadius: "100px",
          }}
        />
      </Stack>
    </>
  );
};

export default SearchTab;
